import { Route, Routes } from "react-router-dom";
import "./App.css";
import DashboardLayout from "./pages/shared/layouts/DashboardLayout";

import Login from "./pages/auth/Login";
import Home from "./pages/public/Home";
import Register from "./pages/auth/Register";
import Dashboard from "./pages/private/Dashboard";
import Archive from "./pages/private/Archive";
import QuestionAnswer from "./pages/private/QuestionAnswer";
import Profile from "./pages/private/Profile";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import NotFound from "./components/NotFound";

function App() {
  return (
    <Routes>
      {/* Public routes - redirect to dashboard if authenticated */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Home />} />
      </Route>

      {/* Private routes - redirect to home if not authenticated */}
      <Route element={<PrivateRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/qa" element={<QuestionAnswer />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
      </Route>

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
